export default __webpack_public_path__ + "static/media/thumbnail.862ca643.png";